var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"routerViewBox",staticClass:"router-video-box"},[_c('stageChangeAnimate',[_c('router-view',{key:_vm.$route.name})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }